/**
 * 关系邀请函
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, message, Input, Button } from 'antd';
import * as Map from 'immutable';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import {
  _change_affinity_modal,
  _get_user_affinity_info,
  _get_user_info,
} from '../../../src/store/Action';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';
import Recharge from '../recharge/Recharge';

const { TextArea } = Input;
class AffinityInvitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'send',
      visible: false,
      loading: false,
      successVisible: false,

      msgText: '',
      tokenInfo: {},
      typeInfo: {},
      otherInfo: {},
      detail: {},
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinityApplyModal);
    const props2 = Map.fromJS(this.props.base.affinityApplyModal);

    if (!this.props.base.affinityApplyModal) {
    } else if (this.props.base.affinityApplyModal && !Map.is(props1, props2)) {
      if (this.props.base.affinityApplyOrderNo) {
        this.showModal({ inviteOrderNo: this.props.base.affinityApplyOrderNo });
      } else if (this.props.base.affinityApplyOtherUid) {
        this.showModal({
          otherUid: this.props.base.affinityApplyOtherUid,
          type: this.props.base.affinityApplyType,
        });
      } else if (this.props.base.affinityApplyDetail) {
        this.showModal({ detail: this.props.base.affinityApplyDetail });
      }
    } else {
    }
  }
  showModal = ({ detail, inviteOrderNo, otherUid, type }) => {
    if (otherUid || inviteOrderNo) {
      let params = {
        otherUid,
        inviteOrderNo,
        type: type == 1 ? 0 : 1,
      };
      let url = '';
      if (inviteOrderNo) {
        url = '_get_affinity_invite_details_msg';
      } else {
        url = '_get_affinity_invite_details';
      }
      HTTP[url](params).then((res) => {
        if (res.code == 200) {
          this.setState({
            type: 'detail',
            visible: true,
            detail: res.data,
            msgText: res.data.remark || '',
          });
        } else {
          message.error(res.message);
        }
      });
    } else {
      this.setState({
        type: 'send',
        visible: true,
        msgText: '',
        detail,
      });
    }
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinityApplyModal: false,
      affinityApplyOtherUid: null,
      affinityApplyDetail: null,
      affinityApplyOrderNo: null,
    });
  };

  hideSuccessModal = () => {
    this.setState({
      successVisible: false,
    });
  };

  onChange = (e) => {
    this.setState({ msgText: e.target.value });
  };
  openRecharge = () => {
    this.rechargeElement.showModal();
  };

  openUnlockModal = (text) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: <span>{text}</span>,
      className: 'daidai-confirm-style',
      okText: '立即解锁',
      cancelText: '我知道了',
      centered: true,
      onOk: () => {
        HTTP._affinity_unlock_bit().then((res) => {
          if (res.code == 200) {
            message.success('解锁成功');
            _get_user_info();
          } else if (res.code == '600402') {
            this.openRechargeModal(res.message);
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };
  openRechargeModal = (text) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: <span>{text}</span>,
      className: 'daidai-confirm-style',
      okText: '去充值',
      cancelText: '关闭',
      centered: true,
      onOk: () => {
        this.openRecharge();
      },
    });
  };

  //发出邀请
  sendInvitation = () => {
    const { detail, msgText } = this.state;
    let params = {
      receiveUid: detail.receiveUid,
      relationConfigId: detail.relationConfigId,
      giftId: detail.giftId,
      giftIdType: detail.giftIdType,
      remark: msgText,
    };
    //信物商品的skuId,当是钻石赠送（giftIdType为1）的时候，该字段需要传
    if (params.giftIdType == 1) {
      params.mallSkuId = detail.mallSkuId;
    }
    HTTP._affinity_send_invite(params).then((res) => {
      if (res.code == 200) {
        message.success('邀请成功');
        this.hideModal();
        _change_affinity_modal({
          affinityDetailModal: false,
          affinityDetailOtherUid: null,
        });
        _get_user_affinity_info();
      } else if (res.code == '600307') {
        this.openUnlockModal(res.message);
      } else if (res.code == '600402') {
        this.openRechargeModal(res.message);
      } else {
        message.error(res.message);
      }
    });
  };
  //同意/拒接邀请
  onRejectOrAccept = (bool) => {
    const { detail } = this.state;
    let params = {
      inviteOrderNo: detail.inviteOrderNo,
      status: bool ? 10 : 20, //10-同意 20-拒绝
    };
    HTTP._affinity_accept_invite(params).then((res) => {
      if (res.code == 200) {
        message.success(bool ? '缔结成功' : '缔结失败');
        if (bool) {
          this.setState({
            successVisible: true,
            detail: res.data,
          });
        }
        this.hideModal();
        _get_user_affinity_info();
      } else if (res.code == '600307') {
        this.openUnlockModal(res.message);
      } else if (res.code == '600402') {
        this.openRechargeModal(res.message);
      } else {
        message.error(res.message);
      }
    });
  };
  seeDetail = () => {
    const { detail } = this.state;
    const {
      receiveUid: otherUid,
      inviterUid: searchUid,
      intimateRelationId,
    } = detail;
    _change_affinity_modal({
      affinitySpaceModal: true,
      affinitySpaceData: { otherUid, searchUid, intimateRelationId },
    });
    this.hideSuccessModal();
  };

  render() {
    const {
      base: { userInfo },
    } = this.props;
    const { loading, type, msgText, detail, visible, successVisible } =
      this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1005}
          className="daidai-modal-invitation "
          closable={false}
          centered={true}
          footer={null}
          keyboard={false}
          maskClosable={false}
          destroyOnHidden
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-invitation">
              <div className="affinity-invitation-title"></div>
              <div
                className="affinity-invitation-close"
                onClick={this.hideModal}
              ></div>
              <div className="affinity-invitation-content">
                <div className="affinity-invitation-avatar">
                  <img
                    src={Util.transImgUrl(detail?.receiveAvatar, '50x50')}
                    alt=""
                  />
                </div>
                <div className="affinity-invitation-name">
                  {detail.receiveNickName}
                </div>
                <div className="affinity-invitation-cover">
                  <img
                    src={Util.transImgUrl(detail?.staticPic, '150x150')}
                    alt=""
                  />
                </div>
                <div className="affinity-invitation-text">
                  献上<span>{detail?.giftName}</span>一份,
                </div>
                <div className="affinity-invitation-text">希望能和你成为</div>
                <div className="affinity-invitation-type">
                  {detail?.invitationIcon ||
                  detail?.relationConfig?.invitationIcon ? (
                    <img
                      src={Util.transImgUrl(
                        detail?.invitationIcon ||
                          detail?.relationConfig?.invitationIcon,
                        '150x100'
                      )}
                      alt=""
                    />
                  ) : null}
                </div>
                {type == 'send' ? (
                  <div className="affinity-invitation-textarea">
                    <TextArea
                      value={msgText}
                      onChange={this.onChange}
                      placeholder="点击输入更多想对TA说的"
                      autoSize={{ minRows: 3, maxRows: 5 }}
                      maxLength={40}
                    />
                    <div className="affinity-invitation-textarea-count">
                      {msgText.length > 40 ? 40 : msgText.length || 0}/40
                    </div>
                  </div>
                ) : detail.remark ? (
                  <>
                    <div className="affinity-invitation-line"></div>
                    <div className="affinity-invitation-text">
                      {detail.remark}
                    </div>
                  </>
                ) : null}
                {type == 'detail' && (
                  <div className="affinity-invitation-initiator">
                    <div className="affinity-invitation-initiator-avatar">
                      <img
                        src={Util.transImgUrl(detail?.inviterAvatar, '50x50')}
                        alt=""
                      />
                    </div>
                    <div className="affinity-invitation-initiator-name">
                      {detail.inviterNickName}
                    </div>
                  </div>
                )}
              </div>
              {/** status 0:邀请中 10:已同意 20:已拒绝  30:已失效 40:待邀请*/}
              <div className="affinity-invitation-bottom">
                {type == 'detail' ? (
                  detail.inviterUid == userInfo.uid ? (
                    <div className="affinity-invitation-action">
                      <div
                        className={`affinity-btn ${detail.status == 20 ? 'disabled' : ''}`}
                      >
                        {detail.status == 0 ? (
                          <span>已邀请，等待对方同意</span>
                        ) : null}
                        {detail.status == 10 ? <span>对方已同意</span> : null}
                        {detail.status == 20 ? <span>对方已拒绝</span> : null}
                        {detail.status == 30 ? <span>已失效</span> : null}
                      </div>
                    </div>
                  ) : detail?.status == 0 ? (
                    <div className="affinity-invitation-action">
                      <div
                        className="affinity-btn reject"
                        onClick={() => this.onRejectOrAccept(false)}
                      >
                        <span>拒绝</span>
                      </div>
                      <div
                        className="affinity-btn primary accept"
                        onClick={() => this.onRejectOrAccept(true)}
                      >
                        <span>同意</span>
                      </div>
                    </div>
                  ) : (
                    <div className="affinity-invitation-action">
                      <div
                        className={`affinity-btn ${detail.status == 20 ? 'disabled' : ''}`}
                      >
                        {detail.status == 10 ? <span>已同意</span> : null}
                        {detail.status == 20 ? <span>已拒绝</span> : null}
                        {detail.status == 30 ? <span>已失效</span> : null}
                      </div>
                    </div>
                  )
                ) : null}
                {detail.status == 20 ? (
                  detail.giftIdType == 0 ? (
                    <div className="reject-text">信物已退回您的背包</div>
                  ) : (
                    <div className="reject-text">钻石已退回您的账户</div>
                  )
                ) : null}
                {type == 'send' ? (
                  <div className="affinity-invitation-action">
                    {detail.giftIdType == 0 ? (
                      <div
                        className="affinity-btn primary"
                        onClick={this.sendInvitation}
                      >
                        <span>发出邀请</span>
                      </div>
                    ) : (
                      <div className="affinity-invitation-action">
                        <div
                          className="affinity-btn primary"
                          onClick={this.sendInvitation}
                        >
                          <span>支付{detail?.skuPrice}钻并发出邀请</span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}
                {type == 'send' && detail.giftIdType == 1 ? (
                  <div className="my-diamond">
                    <p>我的钻石：{userInfo?.diamondAmount || 0}</p>
                    <div className="go-recharge" onClick={this.openRecharge}>
                      去充值
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </DDLoading>
        </Modal>
        <Modal
          open={successVisible}
          zIndex={1003}
          className="daidai-modal-invitation "
          closable={false}
          centered={true}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
        >
          <div
            className={`affinity-success-modal`}
            style={{
              backgroundImage: `url(${Util.transImgUrl(detail?.relationConfig?.conclusionIcon)})`,
            }}
          >
            <div className="affinity-success-box">
              <div className="affinity-success-avatar">
                <div
                  className="affinity-success-avatar-left"
                  style={{
                    border: `3px solid ${detail?.relationConfig?.relationConfigCardStyle}`,
                  }}
                >
                  <img
                    src={Util?.transImgUrl(detail?.inviterAvatar, '70x70')}
                    alt=""
                  />
                </div>
                <div
                  className="affinity-success-avatar-right"
                  style={{
                    border: `3px solid ${detail?.relationConfig?.relationConfigCardStyle}`,
                  }}
                >
                  <img
                    src={Util?.transImgUrl(detail?.receiveAvatar, '70x70')}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <Button
              className="daidai-btn-primary"
              style={{ width: '218px' }}
              onClick={this.seeDetail}
            >
              查看详情
            </Button>
            <div
              className="affinity-success-close"
              onClick={this.hideSuccessModal}
            ></div>
          </div>
        </Modal>
        {/* 充值模块 */}
        <Recharge
          wrappedComponentRef={(el) => (this.rechargeElement = el)}
          base={this.props.base}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityInvitation, { withRef: true })
);
